import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import includes from 'lodash/includes';
import forEach from 'lodash/forEach';
import {
    EDIT_USER_DRAWER,
    FIRST_NAME_PATH,
    LAST_NAME_PATH,
    EMAIL_PATH,
    CONTACT_EMAIL_PATH,
} from 'src/features/users/constants/drawerConstants';
import { Store, showDrawer, setScreenData, getScreenData, ACTIVE_SCREEN_KEY } from 'cw-ui-core';
import { ACTION } from 'src/constants';
import { toArray, toMap, emailRegex } from 'src/util/Util';
import { createSelector } from 'reselect';

export const onRowClick = user => {
    Store().dispatch(setScreenData('activeUserId', user.id));
    const loginScheme = user.loginScheme || 'Local Login';

    Store().dispatch(
        showDrawer(EDIT_USER_DRAWER, {
            activeLoginScheme: loginScheme,
        })
    );
};

export const getAppDisplayName = (applicationBaseName, instanceFriendlyName, productName, appId) => {
    if (applicationBaseName) {
        return !instanceFriendlyName ? `${applicationBaseName}` : `${applicationBaseName} (${instanceFriendlyName})`;
    }
    if (productName) {
        return `${productName} (${appId})`;
    }
    return `${appId}`;
};

export const getCurrentSelection = (path, action, screenKey = ACTIVE_SCREEN_KEY) => {
    switch (action) {
        case ACTION.TYPE_ARRAY:
            return state => {
                return toArray(getScreenData(state.screen, path, screenKey));
            };
        case ACTION.TYPE_MAP:
            return state => {
                return toMap(getScreenData(state.screen, path, screenKey));
            };
        default:
            return state => {
                return getScreenData(state.screen, path, screenKey);
            };
    }
};

export const getNewProductList = (productPath, currentDrawer) => {
    return createSelector(getCurrentSelection(productPath, ACTION.TYPE_ARRAY, currentDrawer), productList => {
        const products = productList?.filter(p => p.clientId);
        forEach(products, (product, idx) => {
            if (product.clientName && product.productName) {
                products[idx].productNameToDisplay = `${product.clientName} (${product.productName})`;
            } else if (product.clientName && !product.productName) {
                products[idx].productNameToDisplay = `${product.clientName}`;
            } else if (!product.clientName && product.productName) {
                products[idx].productNameToDisplay = `(${product.productName})`;
            } else {
                products[idx].productNameToDisplay = product.clientId;
            }
        });
        return products;
    });
};

export const getUserCompletedRequiredFields = currentDrawer => {
    return createSelector(
        getCurrentSelection(FIRST_NAME_PATH, '', currentDrawer),
        getCurrentSelection(LAST_NAME_PATH, '', currentDrawer),
        getCurrentSelection(EMAIL_PATH, '', currentDrawer),
        getCurrentSelection(CONTACT_EMAIL_PATH, '', currentDrawer),
        (firstName, lastName, email, contactEmail) => {
            return (
                firstName?.length > 0 &&
                lastName?.length > 0 &&
                email?.match(emailRegex) &&
                contactEmail?.match(emailRegex)
            );
        }
    );
};

const updateUsersData = (users, selectedIds) => {
    let updatedUsers = [];
    if (!isEmpty(users)) {
        updatedUsers = map(users, user => {
            const isSelected = includes(selectedIds, user.id);
            return { ...user, isSelected };
        });
    }
    return updatedUsers;
};

export default updateUsersData;
